export const acceptQfPayloadAdapter = (trxId, codeInternal, reason, email, observations) => {
	return {
		trx_id: trxId,
		code_internal: codeInternal,
		status: 'RA',
		signature: email,
		approve_type: 'qf-judgment',
		description: reason,
		message: observations,
	};
};
